import { getGoogleClientId } from './customer';


const clientId = getGoogleClientId();

export const googleConfig = {
  client_id: clientId,
  // 必须在 Google Cloud 控制台配置好的回调地址（当前页面的完整 URL）
  redirect_uri: window.location.origin + '/google', 
  response_type: 'id_token', // 隐式授权，直接在 URL 哈希中返回 id_token (JWT)
  scope: 'openid email profile', // 请求获取用户的邮箱和基本资料
  nonce: Math.random().toString(36).substring(2, 15) // 随机字符串，防重放攻击
};
